export const PublicRoutes = {
  /**Login */
  LOGIN: 'login',
  //Forgot Password
  FORGOTPASSWORD: 'forgot-password',
  //Reset Password
  RESETPASSWORD: 'reset-password',
};

export const PrivateRoutes = {
  DASHBOARD: 'dashboard',
  WELCOME: 'welcome',

  /**DATAHUB */
  DATAHUBCRM: 'datahub/crm',

  /**Assets */
  // HOSPITALPRICING: 'assets/hospitalpricing',
  // INPATIENTCLAIMS: 'assets/inpatientclaims',
  // BEHAVIORALHEALTH: 'assets/behavioralhealth',
  // HOSPICE: 'assets/hospice',
  // ZIPCODE: 'assets/zipcode',
  // AHRQ: 'assets/ahrq',
  // CENSUS: 'assets/censusbureau',
  MASTERASSET: 'assets/:asset',

  /**Analytics */
  // //Alcohol
  // MASTERPOWERBI: 'analytics/:category',
  MASTERDASHBOARD: 'analytics/:category',
  // BEVERAGESPOWERBI: 'analytics/beverages',
  // ETHIOPIAN: 'analytics/ethiopian',
  // DELTA: 'analytics/delta',
  // GUATEMALA: 'analytics/guatemala',
  // USAHOLIDAYS: 'analytics/usaholidays',
  // //Health Care
  // HEALTHCAREPOWERBI: 'analytics/healthcare',
  // STELLAMARISPOWERBI: 'analytics/behavioralhealth',
  // HOSPICENORTHEASTOHIOPOWERBI: 'analytics/hospicenortheastohio',
  // //Durables
  // DURABLESPOWERBI: 'analytics/durables',
  // //Digital Marketing
  // DIGITALMARKETINGPOWERBI: 'analytics/digitalmarketing',
  // ETHIOPIA: 'analytics/ethiopia',
  // PARTIES: 'analytics/parties',
  FILEAPPROVAL: 'analytics/fileapproval',

  /**Operations */
  //Product Master
  PRODUCTMAIN: 'operations/productmain',

  //Product Matching
  UNMATCHEDPRODUCTS: 'unmatchedproducts',
  PRODUCTMATCHINGMATCH: 'ProductMatchingMatch',

  //Attribute Matching
  ATTRIBUTEMAPPING: 'attributemapping',

  //Parameters
  PRODUCTMAINPARAMETERS: 'parameters',

  /**Transaction */
  //Transaction Matching
  TRANSACTIONMATCHING: 'transactions/transactionmatching',

  //Transaction Approval
  TRANSACTIONAPPROVAL: 'transactions/transactionapproval',

  /**Validation */
  //Attribute Validation
  ATTRIBUTEVALIDATION: 'validation/pmvalidation/attributevalidation',

  //Single Day Run
  SINGLEDAYRUN: 'operations/validation/scrapingvalidation/singledayrun',

  //Multi Day Run
  MULTIDAYRUNVALIDATION:
    'operations/validation/scrapingvalidation/multidayrunvalidation',

  /**Set Up */
  ATTRIBUTESHUB: 'setup/attributes',
  CATEGORIESHUBII: 'setup/categories',
  CATEGORIESHUB: 'setup/categorieshubprod',
  CROOSREFERENCE: 'setup/cross_reference',
  DASHBOARDHUB: 'setup/dashboards',
  FILEHUB: 'setup/files',
  PIPELINEHUB: 'setup/pipelines',
  USERHUB: 'setup/users',

  DOCUMARK: 'documark',

  PRIVATE: 'private',
  INSIGHTS: 'insights',
  BESTBUYMASTER: 'BestBuyMaster',
  RAWDATA: 'rawdata',
  LOWESMASTER: 'LowesMaster',
  HOMEDEPOT: 'HomeDepot',
  WALMART: 'Walmart',
  AMAZON: 'Amazon',
  PRODUCTUNSCRAPED: 'productunscraped',
  PRODUCTMATCHREVIEW: 'productmatchreview',
  MATCHEDCHART: 'MatchedChart',
  PRODUCTMAINVIEW_ID: 'productmainview/:id',
  PRODUCTMAINVIEWSTD_ID: 'productmainviewstd/:id',
  SELECTEDRULES: 'selectedrules/:id',
  RULESDETAILS: 'rulesdetails/:id',
  ADDRULES: 'addrules/:id',
  CROSSREFERENCEDETAILS: 'cross_reference_datails',
  USERRESET: 'userreset',
  EDITATTRIBUTES_ID: 'editattributes/:id',
  MATHEDTRANSACTIONSVIEW: 'matchedtransactions',
  AUTOCERTIFI: 'AutoCertifi',
  ATTRIBUTETRANSFORMATIONDETAILS: 'attributetransformationdetails/:id',
  BULKEDIT: 'bulkedit/:name',
  PRODUCT: 'product',
  TRANSACTIONSMATCHER: 'transactionsmatcher',

  SCRAPEVALIDATION: 'scrapevalidation',
  ATTRIBUTEMAPPINGORVALUECREATION:
    'operations/productmaster/attributetransfromations/attributemapping/:id/:value',
  GLOBALSEARCH: 'operations/productmaster/globalsearch',
  /**Operations */
  //Product Master
  PRODUCTMATCHINGII: 'operations/productmaster/productmatching/newmatch',
  BULKMAPPING:
    'productmaster/attributematching/bulkattributes/bulkattributemapping',
  //Transactions

  MATCHREVIEW: 'transactions/matchreview',
  //Validation
  DAILYVALIDATION: 'validation/dailyvalidation',
  DAILYFILELOGVALIDATION: 'validation/dailyfilelog',
  FETCHRECEIPTVALIDATION: 'validation/fetchreceipt',
  MOMANDYOYVALIDATION: 'validation/mom&yoy',
  PRICINGVALIDATION: 'validation/filehub',
  PRODUCTWITHCOUNTVALIDATION: 'validation/productwithcount',
  SIMILARWEBVALIDATION: 'validation/similarweb',
  // RAWMETADATAVALIDATION: 'validation/rawmetadata',
};
